import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ActPage } from "@/features/auth/act-page";

export const Route = createFileRoute("/act")({
  validateSearch: z.object({
    token: z.string().min(20).max(200).optional().catch(undefined),
    redirect: z.string().optional().catch(undefined),
  }),
  head: () => ({ meta: [{ title: "Opening… · Rogue AI" }] }),
  component: ActPage,
});
